<script setup lang="ts">
import EditorComponent from './components/EditorComponent.vue'
</script>

<template>
  <div class="app-fullscreen">
    <EditorComponent />
  </div>
</template>
